import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import responsiveSize from 'helper/responsiveSize'

export default styled.div`
  font-family: ${Theme.fontFamily.PRIMARY};
  color: ${Theme.pallete.SECONDARY};
  background: ${Theme.pallete.PRIMARY};
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  .input-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;

  .login-company-logo {
    width: 240px;
    /* preserva proporção */
    /* se quiser limitar */
    margin-bottom: -54px;
    object-fit: contain; /* ajuda em <img> */
  }

  .login-title {
    /* max-height: ${responsiveSize.responsiveHeight(23)}; */
    margin-bottom: 24px;

    @media only screen and (min-width: 1441px) {
      margin-bottom: 27px;
    }
  }

  .login-subtitle {
    margin-bottom: 24px;
    color: ${Theme.pallete.SECONDARY};
    text-align: center;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;

    @media only screen and (min-width: 1441px) {
      font-size: 15px;
      margin-bottom: 27px;
    }
  }
  @media only screen and (min-width: 1441px) {
    font-size: 18px;
  }

  .recovery-subtitle {
    width: 65%;
    margin-bottom: 24px;
    color: ${Theme.pallete.SECONDARY};
    text-align: center;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;

    @media only screen and (min-width: 1441px) {
      font-size: 15px;
      margin-bottom: 27px;
    }
  }
`
